/**
 * Shopify Follow on Shop (v2): gold leaf shimmer + transparent cutouts.
 * Shadow DOM injection; tokens match --product-card-gold-leaf / cert-icon shimmer.
 * destination-out on label, heart, and Shop wordmark punches through gold to footer.
 */
(function () {
  var STYLE_ATTR = 'data-veridame-follow';
  var CUTOUT_SOURCE = '#000';

  var GOLD_LEAF =
    'linear-gradient(135deg,#6e5420 0%,#a67c2d 22%,#ffb81a 45%,#d4af37 62%,#fff1b8 78%,#8a6a2b 100%)';

  var GOLD_SHINE =
    'linear-gradient(115deg,rgba(255,241,184,0) 0%,rgba(255,241,184,0.15) 18%,rgba(255,255,255,0.85) 42%,rgba(255,184,26,0.55) 58%,rgba(255,241,184,0.12) 78%,rgba(255,241,184,0) 100%)';

  var HOST_SELECTORS = [
    'shop-login-button',
    'shop-follow-button',
    'follow-on-shop-button'
  ];

  var GOLD_BG =
    GOLD_SHINE + ',' + GOLD_LEAF;

  function paintCutout(el) {
    if (!el || !el.style) return;
    el.style.setProperty('color', CUTOUT_SOURCE, 'important');
    el.style.setProperty('-webkit-text-fill-color', CUTOUT_SOURCE, 'important');
    el.style.setProperty('fill', CUTOUT_SOURCE, 'important');
    el.style.setProperty('stroke', CUTOUT_SOURCE, 'important');
    el.style.setProperty('mix-blend-mode', 'destination-out', 'important');
    el.style.setProperty('position', 'relative', 'important');
    el.style.setProperty('z-index', '1', 'important');
  }

  function paintGoldLayer(el) {
    if (!el || !el.style) return;
    el.style.setProperty('background-color', 'transparent', 'important');
    el.style.setProperty('background-image', GOLD_BG, 'important');
    el.style.setProperty('background-size', '220% 220%, 100% 100%', 'important');
    el.style.setProperty('background-position', '0% 50%, 0 0', 'important');
    el.style.setProperty('background-repeat', 'no-repeat', 'important');
    el.style.setProperty('opacity', '0.92', 'important');
    el.style.setProperty('z-index', '0', 'important');
  }

  function collectShadowRoots(root, out) {
    if (!root) return;
    var nodes = root.querySelectorAll('*');
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      if (el.shadowRoot) {
        out.push(el.shadowRoot);
        collectShadowRoots(el.shadowRoot, out);
      }
    }
  }

  function findStyleTargets() {
    var roots = [];
    var seen = [];

    function addRoot(root) {
      if (!root || seen.indexOf(root) !== -1) return;
      seen.push(root);
      roots.push(root);
      collectShadowRoots(root, roots);
    }

    HOST_SELECTORS.forEach(function (sel) {
      document.querySelectorAll(sel).forEach(function (host) {
        if (host.shadowRoot) addRoot(host.shadowRoot);
      });
    });

    return roots;
  }

  function isLabelSpan(span) {
    if (!span || span.tagName !== 'SPAN') return false;
    var text = (span.textContent || '').replace(/\s+/g, ' ').trim();
    return /^Follow\s+on/i.test(text);
  }

  function isHeartWrapper(el) {
    if (!el) return false;
    if (!el.classList || !el.classList.contains('px-2')) return false;
    return !!el.querySelector('svg');
  }

  function cssForRoot() {
    return (
      '@keyframes veridame-follow-gold-shimmer{' +
      '0%,100%{background-position:0% 50%,0 0;opacity:0.92}' +
      '50%{background-position:100% 50%,0 0;opacity:1}}' +
      'button{' +
      'background:transparent!important;' +
      'border-color:transparent!important;' +
      'color:transparent!important;' +
      '-webkit-text-fill-color:transparent!important;' +
      'isolation:isolate!important;' +
      'overflow:hidden!important;' +
      'position:relative!important;}' +
      'button .absolute.inset-y-0,' +
      'button [class*="bg-purple"]{' +
      'background-color:transparent!important;' +
      'background-image:' +
      GOLD_BG +
      '!important;' +
      'background-size:220% 220%,100% 100%!important;' +
      'background-position:0% 50%,0 0!important;' +
      'background-repeat:no-repeat!important;' +
      'opacity:0.92!important;' +
      'animation:veridame-follow-gold-shimmer 4.5s ease-in-out infinite!important;' +
      'z-index:0!important;}' +
      'button span.cursor-pointer,' +
      'button span.whitespace-nowrap,' +
      'button span[data-veridame-follow-label],' +
      'button .px-2,' +
      'button .px-2 svg,' +
      'button .px-2 path,' +
      'button span svg,' +
      'button span path,' +
      'button svg,' +
      'button path{' +
      'color:' +
      CUTOUT_SOURCE +
      '!important;' +
      '-webkit-text-fill-color:' +
      CUTOUT_SOURCE +
      '!important;' +
      'fill:' +
      CUTOUT_SOURCE +
      '!important;' +
      'stroke:' +
      CUTOUT_SOURCE +
      '!important;' +
      'mix-blend-mode:destination-out!important;' +
      'position:relative!important;' +
      'z-index:1!important;}' +
      '@media (prefers-reduced-motion:reduce){' +
      'button .absolute.inset-y-0,' +
      'button [class*="bg-purple"]{' +
      'animation:none!important;' +
      'background-position:35% 50%,0 0!important;' +
      'opacity:0.92!important;}}'
    );
  }

  function ensureStyles(root) {
    if (!root || !root.querySelector) return;
    var hasUi = root.querySelector('button span, button svg, button .absolute');
    if (!hasUi) return;

    var styleEl = root.querySelector('style[' + STYLE_ATTR + ']');
    if (!styleEl) {
      styleEl = document.createElement('style');
      styleEl.setAttribute(STYLE_ATTR, 'true');
    }
    styleEl.textContent = cssForRoot();
    root.appendChild(styleEl);
  }

  function styleCutoutElements(button) {
    button.querySelectorAll('.px-2').forEach(function (wrap) {
      if (!isHeartWrapper(wrap)) return;
      wrap.classList.remove('text-white');
      paintCutout(wrap);
      wrap.querySelectorAll('svg, path').forEach(paintCutout);
    });

    button.querySelectorAll('span').forEach(function (span) {
      if (!isLabelSpan(span)) return;
      span.classList.remove('text-white');
      span.setAttribute('data-veridame-follow-label', 'true');
      paintCutout(span);
      span.querySelectorAll('svg, path').forEach(paintCutout);
    });
  }

  function styleRoot(root) {
    ensureStyles(root);

    root.querySelectorAll('button').forEach(function (button) {
      var hasFollow =
        /Follow\s+on/i.test(button.textContent || '') ||
        button.querySelector('svg[viewBox="0 0 60 25"], svg[viewBox="0 0 20 20"]');
      if (!hasFollow) return;

      button.style.setProperty('background', 'transparent', 'important');
      button.style.setProperty('border-color', 'transparent', 'important');
      button.style.setProperty('isolation', 'isolate', 'important');
      button.style.setProperty('overflow', 'hidden', 'important');

      button.querySelectorAll('.absolute.inset-y-0, [class*="bg-purple"]').forEach(function (el) {
        paintGoldLayer(el);
      });

      styleCutoutElements(button);
    });
  }

  function scan() {
    findStyleTargets().forEach(styleRoot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan);
  } else {
    scan();
  }

  var observer = new MutationObserver(scan);
  observer.observe(document.documentElement, { childList: true, subtree: true });

  [50, 200, 500, 1000, 2000, 4000].forEach(function (ms) {
    setTimeout(scan, ms);
  });
})();
